/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainRouteRouteImport } from './routes/_main/route'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSignoutRouteImport } from './routes/auth/signout'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as MainTeamRouteImport } from './routes/_main/team'
import { Route as MainSecretsRouteImport } from './routes/_main/secrets'
import { Route as MainDomainsRouteImport } from './routes/_main/domains'
import { Route as MainDeployRouteImport } from './routes/_main/deploy'
import { Route as MainActivityRouteImport } from './routes/_main/activity'
import { Route as MainVolumesRouteRouteImport } from './routes/_main/volumes/route'
import { Route as MainSettingsRouteRouteImport } from './routes/_main/settings/route'
import { Route as MainSandboxesRouteRouteImport } from './routes/_main/sandboxes/route'
import { Route as MainOneClicksRouteRouteImport } from './routes/_main/one-clicks/route'
import { Route as MainVolumesIndexRouteImport } from './routes/_main/volumes/index'
import { Route as MainSettingsIndexRouteImport } from './routes/_main/settings/index'
import { Route as MainServicesIndexRouteImport } from './routes/_main/services/index'
import { Route as MainSandboxesIndexRouteImport } from './routes/_main/sandboxes/index'
import { Route as MainOneClicksIndexRouteImport } from './routes/_main/one-clicks/index'
import { Route as AccountWorkosCallbackRouteImport } from './routes/account/workos.callback'
import { Route as AccountOrganization_invitationsInvitationIdRouteImport } from './routes/account/organization_invitations.$invitationId'
import { Route as MainVolumesSnapshotsRouteImport } from './routes/_main/volumes/snapshots'
import { Route as MainVolumesNewRouteImport } from './routes/_main/volumes/new'
import { Route as MainSettingsRegistryConfigurationRouteImport } from './routes/_main/settings/registry-configuration'
import { Route as MainSettingsPlansRouteImport } from './routes/_main/settings/plans'
import { Route as MainSettingsBillingRouteImport } from './routes/_main/settings/billing'
import { Route as MainSettingsApiRouteImport } from './routes/_main/settings/api'
import { Route as MainServicesNewRouteImport } from './routes/_main/services/new'
import { Route as MainServicesDeployRouteImport } from './routes/_main/services/deploy'
import { Route as MainDatabaseServicesNewRouteImport } from './routes/_main/database-services/new'
import { Route as MainUserSettingsRouteRouteImport } from './routes/_main/user.settings/route'
import { Route as MainServicesServiceIdRouteRouteImport } from './routes/_main/services/$serviceId/route'
import { Route as MainSandboxesServiceIdRouteRouteImport } from './routes/_main/sandboxes/$serviceId/route'
import { Route as MainOneClicksSlugRouteRouteImport } from './routes/_main/one-clicks/$slug.route'
import { Route as MainDatabaseServicesDatabaseServiceIdRouteRouteImport } from './routes/_main/database-services/$databaseServiceId/route'
import { Route as MainUserSettingsIndexRouteImport } from './routes/_main/user.settings/index'
import { Route as MainServicesServiceIdIndexRouteImport } from './routes/_main/services/$serviceId/index'
import { Route as MainSandboxesServiceIdIndexRouteImport } from './routes/_main/sandboxes/$serviceId/index'
import { Route as MainProjectSettingsIndexRouteImport } from './routes/_main/project.settings/index'
import { Route as MainOneClicksSlugIndexRouteImport } from './routes/_main/one-clicks/$slug.index'
import { Route as MainDatabaseServicesDatabaseServiceIdIndexRouteImport } from './routes/_main/database-services/$databaseServiceId/index'
import { Route as OrganizationDeactivateConfirmConfirmationIdRouteImport } from './routes/organization/deactivate.confirm.$confirmationId'
import { Route as AccountOauthGithubCallbackRouteImport } from './routes/account/oauth.github.callback'
import { Route as MainUserSettingsOrganizationsRouteImport } from './routes/_main/user.settings/organizations'
import { Route as MainUserSettingsApiRouteImport } from './routes/_main/user.settings/api'
import { Route as MainServicesServiceIdSettingsRouteImport } from './routes/_main/services/$serviceId/settings'
import { Route as MainServicesServiceIdMetricsRouteImport } from './routes/_main/services/$serviceId/metrics'
import { Route as MainServicesServiceIdConsoleRouteImport } from './routes/_main/services/$serviceId/console'
import { Route as MainSandboxesServiceIdMetricsRouteImport } from './routes/_main/sandboxes/$serviceId/metrics'
import { Route as MainSandboxesServiceIdConsoleRouteImport } from './routes/_main/sandboxes/$serviceId/console'
import { Route as MainOneClicksSlugDeployRouteImport } from './routes/_main/one-clicks/$slug.deploy'
import { Route as MainDatabaseServicesDatabaseServiceIdSettingsRouteImport } from './routes/_main/database-services/$databaseServiceId/settings'
import { Route as MainDatabaseServicesDatabaseServiceIdRolesRouteImport } from './routes/_main/database-services/$databaseServiceId/roles'
import { Route as MainDatabaseServicesDatabaseServiceIdDatabasesRouteImport } from './routes/_main/database-services/$databaseServiceId/databases'
import { Route as MainAuthSsoDiscourseRouteImport } from './routes/_main/auth/sso.discourse'
import { Route as MainAuthSsoCannyRouteImport } from './routes/_main/auth/sso.canny'

const MainRouteRoute = MainRouteRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignoutRoute = AuthSignoutRouteImport.update({
  id: '/auth/signout',
  path: '/auth/signout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const MainTeamRoute = MainTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainSecretsRoute = MainSecretsRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainDomainsRoute = MainDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainDeployRoute = MainDeployRouteImport.update({
  id: '/deploy',
  path: '/deploy',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainActivityRoute = MainActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainVolumesRouteRoute = MainVolumesRouteRouteImport.update({
  id: '/volumes',
  path: '/volumes',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainSettingsRouteRoute = MainSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainSandboxesRouteRoute = MainSandboxesRouteRouteImport.update({
  id: '/sandboxes',
  path: '/sandboxes',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainOneClicksRouteRoute = MainOneClicksRouteRouteImport.update({
  id: '/one-clicks',
  path: '/one-clicks',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainVolumesIndexRoute = MainVolumesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainVolumesRouteRoute,
} as any)
const MainSettingsIndexRoute = MainSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainServicesIndexRoute = MainServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainSandboxesIndexRoute = MainSandboxesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainSandboxesRouteRoute,
} as any)
const MainOneClicksIndexRoute = MainOneClicksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainOneClicksRouteRoute,
} as any)
const AccountWorkosCallbackRoute = AccountWorkosCallbackRouteImport.update({
  id: '/account/workos/callback',
  path: '/account/workos/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountOrganization_invitationsInvitationIdRoute =
  AccountOrganization_invitationsInvitationIdRouteImport.update({
    id: '/account/organization_invitations/$invitationId',
    path: '/account/organization_invitations/$invitationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MainVolumesSnapshotsRoute = MainVolumesSnapshotsRouteImport.update({
  id: '/snapshots',
  path: '/snapshots',
  getParentRoute: () => MainVolumesRouteRoute,
} as any)
const MainVolumesNewRoute = MainVolumesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => MainVolumesRouteRoute,
} as any)
const MainSettingsRegistryConfigurationRoute =
  MainSettingsRegistryConfigurationRouteImport.update({
    id: '/registry-configuration',
    path: '/registry-configuration',
    getParentRoute: () => MainSettingsRouteRoute,
  } as any)
const MainSettingsPlansRoute = MainSettingsPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsBillingRoute = MainSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsApiRoute = MainSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainServicesNewRoute = MainServicesNewRouteImport.update({
  id: '/services/new',
  path: '/services/new',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainServicesDeployRoute = MainServicesDeployRouteImport.update({
  id: '/services/deploy',
  path: '/services/deploy',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainDatabaseServicesNewRoute = MainDatabaseServicesNewRouteImport.update({
  id: '/database-services/new',
  path: '/database-services/new',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainUserSettingsRouteRoute = MainUserSettingsRouteRouteImport.update({
  id: '/user/settings',
  path: '/user/settings',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainServicesServiceIdRouteRoute =
  MainServicesServiceIdRouteRouteImport.update({
    id: '/services/$serviceId',
    path: '/services/$serviceId',
    getParentRoute: () => MainRouteRoute,
  } as any)
const MainSandboxesServiceIdRouteRoute =
  MainSandboxesServiceIdRouteRouteImport.update({
    id: '/$serviceId',
    path: '/$serviceId',
    getParentRoute: () => MainSandboxesRouteRoute,
  } as any)
const MainOneClicksSlugRouteRoute = MainOneClicksSlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => MainOneClicksRouteRoute,
} as any)
const MainDatabaseServicesDatabaseServiceIdRouteRoute =
  MainDatabaseServicesDatabaseServiceIdRouteRouteImport.update({
    id: '/database-services/$databaseServiceId',
    path: '/database-services/$databaseServiceId',
    getParentRoute: () => MainRouteRoute,
  } as any)
const MainUserSettingsIndexRoute = MainUserSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainUserSettingsRouteRoute,
} as any)
const MainServicesServiceIdIndexRoute =
  MainServicesServiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainServicesServiceIdRouteRoute,
  } as any)
const MainSandboxesServiceIdIndexRoute =
  MainSandboxesServiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainSandboxesServiceIdRouteRoute,
  } as any)
const MainProjectSettingsIndexRoute =
  MainProjectSettingsIndexRouteImport.update({
    id: '/project/settings/',
    path: '/project/settings/',
    getParentRoute: () => MainRouteRoute,
  } as any)
const MainOneClicksSlugIndexRoute = MainOneClicksSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainOneClicksSlugRouteRoute,
} as any)
const MainDatabaseServicesDatabaseServiceIdIndexRoute =
  MainDatabaseServicesDatabaseServiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainDatabaseServicesDatabaseServiceIdRouteRoute,
  } as any)
const OrganizationDeactivateConfirmConfirmationIdRoute =
  OrganizationDeactivateConfirmConfirmationIdRouteImport.update({
    id: '/organization/deactivate/confirm/$confirmationId',
    path: '/organization/deactivate/confirm/$confirmationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountOauthGithubCallbackRoute =
  AccountOauthGithubCallbackRouteImport.update({
    id: '/account/oauth/github/callback',
    path: '/account/oauth/github/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const MainUserSettingsOrganizationsRoute =
  MainUserSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => MainUserSettingsRouteRoute,
  } as any)
const MainUserSettingsApiRoute = MainUserSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => MainUserSettingsRouteRoute,
} as any)
const MainServicesServiceIdSettingsRoute =
  MainServicesServiceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => MainServicesServiceIdRouteRoute,
  } as any)
const MainServicesServiceIdMetricsRoute =
  MainServicesServiceIdMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => MainServicesServiceIdRouteRoute,
  } as any)
const MainServicesServiceIdConsoleRoute =
  MainServicesServiceIdConsoleRouteImport.update({
    id: '/console',
    path: '/console',
    getParentRoute: () => MainServicesServiceIdRouteRoute,
  } as any)
const MainSandboxesServiceIdMetricsRoute =
  MainSandboxesServiceIdMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => MainSandboxesServiceIdRouteRoute,
  } as any)
const MainSandboxesServiceIdConsoleRoute =
  MainSandboxesServiceIdConsoleRouteImport.update({
    id: '/console',
    path: '/console',
    getParentRoute: () => MainSandboxesServiceIdRouteRoute,
  } as any)
const MainOneClicksSlugDeployRoute = MainOneClicksSlugDeployRouteImport.update({
  id: '/deploy',
  path: '/deploy',
  getParentRoute: () => MainOneClicksSlugRouteRoute,
} as any)
const MainDatabaseServicesDatabaseServiceIdSettingsRoute =
  MainDatabaseServicesDatabaseServiceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => MainDatabaseServicesDatabaseServiceIdRouteRoute,
  } as any)
const MainDatabaseServicesDatabaseServiceIdRolesRoute =
  MainDatabaseServicesDatabaseServiceIdRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => MainDatabaseServicesDatabaseServiceIdRouteRoute,
  } as any)
const MainDatabaseServicesDatabaseServiceIdDatabasesRoute =
  MainDatabaseServicesDatabaseServiceIdDatabasesRouteImport.update({
    id: '/databases',
    path: '/databases',
    getParentRoute: () => MainDatabaseServicesDatabaseServiceIdRouteRoute,
  } as any)
const MainAuthSsoDiscourseRoute = MainAuthSsoDiscourseRouteImport.update({
  id: '/auth/sso/discourse',
  path: '/auth/sso/discourse',
  getParentRoute: () => MainRouteRoute,
} as any)
const MainAuthSsoCannyRoute = MainAuthSsoCannyRouteImport.update({
  id: '/auth/sso/canny',
  path: '/auth/sso/canny',
  getParentRoute: () => MainRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MainIndexRoute
  '/one-clicks': typeof MainOneClicksRouteRouteWithChildren
  '/sandboxes': typeof MainSandboxesRouteRouteWithChildren
  '/settings': typeof MainSettingsRouteRouteWithChildren
  '/volumes': typeof MainVolumesRouteRouteWithChildren
  '/activity': typeof MainActivityRoute
  '/deploy': typeof MainDeployRoute
  '/domains': typeof MainDomainsRoute
  '/secrets': typeof MainSecretsRoute
  '/team': typeof MainTeamRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/database-services/$databaseServiceId': typeof MainDatabaseServicesDatabaseServiceIdRouteRouteWithChildren
  '/one-clicks/$slug': typeof MainOneClicksSlugRouteRouteWithChildren
  '/sandboxes/$serviceId': typeof MainSandboxesServiceIdRouteRouteWithChildren
  '/services/$serviceId': typeof MainServicesServiceIdRouteRouteWithChildren
  '/user/settings': typeof MainUserSettingsRouteRouteWithChildren
  '/database-services/new': typeof MainDatabaseServicesNewRoute
  '/services/deploy': typeof MainServicesDeployRoute
  '/services/new': typeof MainServicesNewRoute
  '/settings/api': typeof MainSettingsApiRoute
  '/settings/billing': typeof MainSettingsBillingRoute
  '/settings/plans': typeof MainSettingsPlansRoute
  '/settings/registry-configuration': typeof MainSettingsRegistryConfigurationRoute
  '/volumes/new': typeof MainVolumesNewRoute
  '/volumes/snapshots': typeof MainVolumesSnapshotsRoute
  '/account/organization_invitations/$invitationId': typeof AccountOrganization_invitationsInvitationIdRoute
  '/account/workos/callback': typeof AccountWorkosCallbackRoute
  '/one-clicks/': typeof MainOneClicksIndexRoute
  '/sandboxes/': typeof MainSandboxesIndexRoute
  '/services/': typeof MainServicesIndexRoute
  '/settings/': typeof MainSettingsIndexRoute
  '/volumes/': typeof MainVolumesIndexRoute
  '/auth/sso/canny': typeof MainAuthSsoCannyRoute
  '/auth/sso/discourse': typeof MainAuthSsoDiscourseRoute
  '/database-services/$databaseServiceId/databases': typeof MainDatabaseServicesDatabaseServiceIdDatabasesRoute
  '/database-services/$databaseServiceId/roles': typeof MainDatabaseServicesDatabaseServiceIdRolesRoute
  '/database-services/$databaseServiceId/settings': typeof MainDatabaseServicesDatabaseServiceIdSettingsRoute
  '/one-clicks/$slug/deploy': typeof MainOneClicksSlugDeployRoute
  '/sandboxes/$serviceId/console': typeof MainSandboxesServiceIdConsoleRoute
  '/sandboxes/$serviceId/metrics': typeof MainSandboxesServiceIdMetricsRoute
  '/services/$serviceId/console': typeof MainServicesServiceIdConsoleRoute
  '/services/$serviceId/metrics': typeof MainServicesServiceIdMetricsRoute
  '/services/$serviceId/settings': typeof MainServicesServiceIdSettingsRoute
  '/user/settings/api': typeof MainUserSettingsApiRoute
  '/user/settings/organizations': typeof MainUserSettingsOrganizationsRoute
  '/account/oauth/github/callback': typeof AccountOauthGithubCallbackRoute
  '/organization/deactivate/confirm/$confirmationId': typeof OrganizationDeactivateConfirmConfirmationIdRoute
  '/database-services/$databaseServiceId/': typeof MainDatabaseServicesDatabaseServiceIdIndexRoute
  '/one-clicks/$slug/': typeof MainOneClicksSlugIndexRoute
  '/project/settings/': typeof MainProjectSettingsIndexRoute
  '/sandboxes/$serviceId/': typeof MainSandboxesServiceIdIndexRoute
  '/services/$serviceId/': typeof MainServicesServiceIdIndexRoute
  '/user/settings/': typeof MainUserSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/activity': typeof MainActivityRoute
  '/deploy': typeof MainDeployRoute
  '/domains': typeof MainDomainsRoute
  '/secrets': typeof MainSecretsRoute
  '/team': typeof MainTeamRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/': typeof MainIndexRoute
  '/database-services/new': typeof MainDatabaseServicesNewRoute
  '/services/deploy': typeof MainServicesDeployRoute
  '/services/new': typeof MainServicesNewRoute
  '/settings/api': typeof MainSettingsApiRoute
  '/settings/billing': typeof MainSettingsBillingRoute
  '/settings/plans': typeof MainSettingsPlansRoute
  '/settings/registry-configuration': typeof MainSettingsRegistryConfigurationRoute
  '/volumes/new': typeof MainVolumesNewRoute
  '/volumes/snapshots': typeof MainVolumesSnapshotsRoute
  '/account/organization_invitations/$invitationId': typeof AccountOrganization_invitationsInvitationIdRoute
  '/account/workos/callback': typeof AccountWorkosCallbackRoute
  '/one-clicks': typeof MainOneClicksIndexRoute
  '/sandboxes': typeof MainSandboxesIndexRoute
  '/services': typeof MainServicesIndexRoute
  '/settings': typeof MainSettingsIndexRoute
  '/volumes': typeof MainVolumesIndexRoute
  '/auth/sso/canny': typeof MainAuthSsoCannyRoute
  '/auth/sso/discourse': typeof MainAuthSsoDiscourseRoute
  '/database-services/$databaseServiceId/databases': typeof MainDatabaseServicesDatabaseServiceIdDatabasesRoute
  '/database-services/$databaseServiceId/roles': typeof MainDatabaseServicesDatabaseServiceIdRolesRoute
  '/database-services/$databaseServiceId/settings': typeof MainDatabaseServicesDatabaseServiceIdSettingsRoute
  '/one-clicks/$slug/deploy': typeof MainOneClicksSlugDeployRoute
  '/sandboxes/$serviceId/console': typeof MainSandboxesServiceIdConsoleRoute
  '/sandboxes/$serviceId/metrics': typeof MainSandboxesServiceIdMetricsRoute
  '/services/$serviceId/console': typeof MainServicesServiceIdConsoleRoute
  '/services/$serviceId/metrics': typeof MainServicesServiceIdMetricsRoute
  '/services/$serviceId/settings': typeof MainServicesServiceIdSettingsRoute
  '/user/settings/api': typeof MainUserSettingsApiRoute
  '/user/settings/organizations': typeof MainUserSettingsOrganizationsRoute
  '/account/oauth/github/callback': typeof AccountOauthGithubCallbackRoute
  '/organization/deactivate/confirm/$confirmationId': typeof OrganizationDeactivateConfirmConfirmationIdRoute
  '/database-services/$databaseServiceId': typeof MainDatabaseServicesDatabaseServiceIdIndexRoute
  '/one-clicks/$slug': typeof MainOneClicksSlugIndexRoute
  '/project/settings': typeof MainProjectSettingsIndexRoute
  '/sandboxes/$serviceId': typeof MainSandboxesServiceIdIndexRoute
  '/services/$serviceId': typeof MainServicesServiceIdIndexRoute
  '/user/settings': typeof MainUserSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_main': typeof MainRouteRouteWithChildren
  '/_main/one-clicks': typeof MainOneClicksRouteRouteWithChildren
  '/_main/sandboxes': typeof MainSandboxesRouteRouteWithChildren
  '/_main/settings': typeof MainSettingsRouteRouteWithChildren
  '/_main/volumes': typeof MainVolumesRouteRouteWithChildren
  '/_main/activity': typeof MainActivityRoute
  '/_main/deploy': typeof MainDeployRoute
  '/_main/domains': typeof MainDomainsRoute
  '/_main/secrets': typeof MainSecretsRoute
  '/_main/team': typeof MainTeamRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/_main/': typeof MainIndexRoute
  '/_main/database-services/$databaseServiceId': typeof MainDatabaseServicesDatabaseServiceIdRouteRouteWithChildren
  '/_main/one-clicks/$slug': typeof MainOneClicksSlugRouteRouteWithChildren
  '/_main/sandboxes/$serviceId': typeof MainSandboxesServiceIdRouteRouteWithChildren
  '/_main/services/$serviceId': typeof MainServicesServiceIdRouteRouteWithChildren
  '/_main/user/settings': typeof MainUserSettingsRouteRouteWithChildren
  '/_main/database-services/new': typeof MainDatabaseServicesNewRoute
  '/_main/services/deploy': typeof MainServicesDeployRoute
  '/_main/services/new': typeof MainServicesNewRoute
  '/_main/settings/api': typeof MainSettingsApiRoute
  '/_main/settings/billing': typeof MainSettingsBillingRoute
  '/_main/settings/plans': typeof MainSettingsPlansRoute
  '/_main/settings/registry-configuration': typeof MainSettingsRegistryConfigurationRoute
  '/_main/volumes/new': typeof MainVolumesNewRoute
  '/_main/volumes/snapshots': typeof MainVolumesSnapshotsRoute
  '/account/organization_invitations/$invitationId': typeof AccountOrganization_invitationsInvitationIdRoute
  '/account/workos/callback': typeof AccountWorkosCallbackRoute
  '/_main/one-clicks/': typeof MainOneClicksIndexRoute
  '/_main/sandboxes/': typeof MainSandboxesIndexRoute
  '/_main/services/': typeof MainServicesIndexRoute
  '/_main/settings/': typeof MainSettingsIndexRoute
  '/_main/volumes/': typeof MainVolumesIndexRoute
  '/_main/auth/sso/canny': typeof MainAuthSsoCannyRoute
  '/_main/auth/sso/discourse': typeof MainAuthSsoDiscourseRoute
  '/_main/database-services/$databaseServiceId/databases': typeof MainDatabaseServicesDatabaseServiceIdDatabasesRoute
  '/_main/database-services/$databaseServiceId/roles': typeof MainDatabaseServicesDatabaseServiceIdRolesRoute
  '/_main/database-services/$databaseServiceId/settings': typeof MainDatabaseServicesDatabaseServiceIdSettingsRoute
  '/_main/one-clicks/$slug/deploy': typeof MainOneClicksSlugDeployRoute
  '/_main/sandboxes/$serviceId/console': typeof MainSandboxesServiceIdConsoleRoute
  '/_main/sandboxes/$serviceId/metrics': typeof MainSandboxesServiceIdMetricsRoute
  '/_main/services/$serviceId/console': typeof MainServicesServiceIdConsoleRoute
  '/_main/services/$serviceId/metrics': typeof MainServicesServiceIdMetricsRoute
  '/_main/services/$serviceId/settings': typeof MainServicesServiceIdSettingsRoute
  '/_main/user/settings/api': typeof MainUserSettingsApiRoute
  '/_main/user/settings/organizations': typeof MainUserSettingsOrganizationsRoute
  '/account/oauth/github/callback': typeof AccountOauthGithubCallbackRoute
  '/organization/deactivate/confirm/$confirmationId': typeof OrganizationDeactivateConfirmConfirmationIdRoute
  '/_main/database-services/$databaseServiceId/': typeof MainDatabaseServicesDatabaseServiceIdIndexRoute
  '/_main/one-clicks/$slug/': typeof MainOneClicksSlugIndexRoute
  '/_main/project/settings/': typeof MainProjectSettingsIndexRoute
  '/_main/sandboxes/$serviceId/': typeof MainSandboxesServiceIdIndexRoute
  '/_main/services/$serviceId/': typeof MainServicesServiceIdIndexRoute
  '/_main/user/settings/': typeof MainUserSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/one-clicks'
    | '/sandboxes'
    | '/settings'
    | '/volumes'
    | '/activity'
    | '/deploy'
    | '/domains'
    | '/secrets'
    | '/team'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/signup'
    | '/database-services/$databaseServiceId'
    | '/one-clicks/$slug'
    | '/sandboxes/$serviceId'
    | '/services/$serviceId'
    | '/user/settings'
    | '/database-services/new'
    | '/services/deploy'
    | '/services/new'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/registry-configuration'
    | '/volumes/new'
    | '/volumes/snapshots'
    | '/account/organization_invitations/$invitationId'
    | '/account/workos/callback'
    | '/one-clicks/'
    | '/sandboxes/'
    | '/services/'
    | '/settings/'
    | '/volumes/'
    | '/auth/sso/canny'
    | '/auth/sso/discourse'
    | '/database-services/$databaseServiceId/databases'
    | '/database-services/$databaseServiceId/roles'
    | '/database-services/$databaseServiceId/settings'
    | '/one-clicks/$slug/deploy'
    | '/sandboxes/$serviceId/console'
    | '/sandboxes/$serviceId/metrics'
    | '/services/$serviceId/console'
    | '/services/$serviceId/metrics'
    | '/services/$serviceId/settings'
    | '/user/settings/api'
    | '/user/settings/organizations'
    | '/account/oauth/github/callback'
    | '/organization/deactivate/confirm/$confirmationId'
    | '/database-services/$databaseServiceId/'
    | '/one-clicks/$slug/'
    | '/project/settings/'
    | '/sandboxes/$serviceId/'
    | '/services/$serviceId/'
    | '/user/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/activity'
    | '/deploy'
    | '/domains'
    | '/secrets'
    | '/team'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/signup'
    | '/'
    | '/database-services/new'
    | '/services/deploy'
    | '/services/new'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/registry-configuration'
    | '/volumes/new'
    | '/volumes/snapshots'
    | '/account/organization_invitations/$invitationId'
    | '/account/workos/callback'
    | '/one-clicks'
    | '/sandboxes'
    | '/services'
    | '/settings'
    | '/volumes'
    | '/auth/sso/canny'
    | '/auth/sso/discourse'
    | '/database-services/$databaseServiceId/databases'
    | '/database-services/$databaseServiceId/roles'
    | '/database-services/$databaseServiceId/settings'
    | '/one-clicks/$slug/deploy'
    | '/sandboxes/$serviceId/console'
    | '/sandboxes/$serviceId/metrics'
    | '/services/$serviceId/console'
    | '/services/$serviceId/metrics'
    | '/services/$serviceId/settings'
    | '/user/settings/api'
    | '/user/settings/organizations'
    | '/account/oauth/github/callback'
    | '/organization/deactivate/confirm/$confirmationId'
    | '/database-services/$databaseServiceId'
    | '/one-clicks/$slug'
    | '/project/settings'
    | '/sandboxes/$serviceId'
    | '/services/$serviceId'
    | '/user/settings'
  id:
    | '__root__'
    | '/_main'
    | '/_main/one-clicks'
    | '/_main/sandboxes'
    | '/_main/settings'
    | '/_main/volumes'
    | '/_main/activity'
    | '/_main/deploy'
    | '/_main/domains'
    | '/_main/secrets'
    | '/_main/team'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/signup'
    | '/_main/'
    | '/_main/database-services/$databaseServiceId'
    | '/_main/one-clicks/$slug'
    | '/_main/sandboxes/$serviceId'
    | '/_main/services/$serviceId'
    | '/_main/user/settings'
    | '/_main/database-services/new'
    | '/_main/services/deploy'
    | '/_main/services/new'
    | '/_main/settings/api'
    | '/_main/settings/billing'
    | '/_main/settings/plans'
    | '/_main/settings/registry-configuration'
    | '/_main/volumes/new'
    | '/_main/volumes/snapshots'
    | '/account/organization_invitations/$invitationId'
    | '/account/workos/callback'
    | '/_main/one-clicks/'
    | '/_main/sandboxes/'
    | '/_main/services/'
    | '/_main/settings/'
    | '/_main/volumes/'
    | '/_main/auth/sso/canny'
    | '/_main/auth/sso/discourse'
    | '/_main/database-services/$databaseServiceId/databases'
    | '/_main/database-services/$databaseServiceId/roles'
    | '/_main/database-services/$databaseServiceId/settings'
    | '/_main/one-clicks/$slug/deploy'
    | '/_main/sandboxes/$serviceId/console'
    | '/_main/sandboxes/$serviceId/metrics'
    | '/_main/services/$serviceId/console'
    | '/_main/services/$serviceId/metrics'
    | '/_main/services/$serviceId/settings'
    | '/_main/user/settings/api'
    | '/_main/user/settings/organizations'
    | '/account/oauth/github/callback'
    | '/organization/deactivate/confirm/$confirmationId'
    | '/_main/database-services/$databaseServiceId/'
    | '/_main/one-clicks/$slug/'
    | '/_main/project/settings/'
    | '/_main/sandboxes/$serviceId/'
    | '/_main/services/$serviceId/'
    | '/_main/user/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MainRouteRoute: typeof MainRouteRouteWithChildren
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignoutRoute: typeof AuthSignoutRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AccountOrganization_invitationsInvitationIdRoute: typeof AccountOrganization_invitationsInvitationIdRoute
  AccountWorkosCallbackRoute: typeof AccountWorkosCallbackRoute
  AccountOauthGithubCallbackRoute: typeof AccountOauthGithubCallbackRoute
  OrganizationDeactivateConfirmConfirmationIdRoute: typeof OrganizationDeactivateConfirmConfirmationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signout': {
      id: '/auth/signout'
      path: '/auth/signout'
      fullPath: '/auth/signout'
      preLoaderRoute: typeof AuthSignoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/team': {
      id: '/_main/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof MainTeamRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/secrets': {
      id: '/_main/secrets'
      path: '/secrets'
      fullPath: '/secrets'
      preLoaderRoute: typeof MainSecretsRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/domains': {
      id: '/_main/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof MainDomainsRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/deploy': {
      id: '/_main/deploy'
      path: '/deploy'
      fullPath: '/deploy'
      preLoaderRoute: typeof MainDeployRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/activity': {
      id: '/_main/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof MainActivityRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/volumes': {
      id: '/_main/volumes'
      path: '/volumes'
      fullPath: '/volumes'
      preLoaderRoute: typeof MainVolumesRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/settings': {
      id: '/_main/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MainSettingsRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/sandboxes': {
      id: '/_main/sandboxes'
      path: '/sandboxes'
      fullPath: '/sandboxes'
      preLoaderRoute: typeof MainSandboxesRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/one-clicks': {
      id: '/_main/one-clicks'
      path: '/one-clicks'
      fullPath: '/one-clicks'
      preLoaderRoute: typeof MainOneClicksRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/volumes/': {
      id: '/_main/volumes/'
      path: '/'
      fullPath: '/volumes/'
      preLoaderRoute: typeof MainVolumesIndexRouteImport
      parentRoute: typeof MainVolumesRouteRoute
    }
    '/_main/settings/': {
      id: '/_main/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof MainSettingsIndexRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/services/': {
      id: '/_main/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof MainServicesIndexRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/sandboxes/': {
      id: '/_main/sandboxes/'
      path: '/'
      fullPath: '/sandboxes/'
      preLoaderRoute: typeof MainSandboxesIndexRouteImport
      parentRoute: typeof MainSandboxesRouteRoute
    }
    '/_main/one-clicks/': {
      id: '/_main/one-clicks/'
      path: '/'
      fullPath: '/one-clicks/'
      preLoaderRoute: typeof MainOneClicksIndexRouteImport
      parentRoute: typeof MainOneClicksRouteRoute
    }
    '/account/workos/callback': {
      id: '/account/workos/callback'
      path: '/account/workos/callback'
      fullPath: '/account/workos/callback'
      preLoaderRoute: typeof AccountWorkosCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/organization_invitations/$invitationId': {
      id: '/account/organization_invitations/$invitationId'
      path: '/account/organization_invitations/$invitationId'
      fullPath: '/account/organization_invitations/$invitationId'
      preLoaderRoute: typeof AccountOrganization_invitationsInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/volumes/snapshots': {
      id: '/_main/volumes/snapshots'
      path: '/snapshots'
      fullPath: '/volumes/snapshots'
      preLoaderRoute: typeof MainVolumesSnapshotsRouteImport
      parentRoute: typeof MainVolumesRouteRoute
    }
    '/_main/volumes/new': {
      id: '/_main/volumes/new'
      path: '/new'
      fullPath: '/volumes/new'
      preLoaderRoute: typeof MainVolumesNewRouteImport
      parentRoute: typeof MainVolumesRouteRoute
    }
    '/_main/settings/registry-configuration': {
      id: '/_main/settings/registry-configuration'
      path: '/registry-configuration'
      fullPath: '/settings/registry-configuration'
      preLoaderRoute: typeof MainSettingsRegistryConfigurationRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/plans': {
      id: '/_main/settings/plans'
      path: '/plans'
      fullPath: '/settings/plans'
      preLoaderRoute: typeof MainSettingsPlansRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/billing': {
      id: '/_main/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof MainSettingsBillingRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/api': {
      id: '/_main/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof MainSettingsApiRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/services/new': {
      id: '/_main/services/new'
      path: '/services/new'
      fullPath: '/services/new'
      preLoaderRoute: typeof MainServicesNewRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/services/deploy': {
      id: '/_main/services/deploy'
      path: '/services/deploy'
      fullPath: '/services/deploy'
      preLoaderRoute: typeof MainServicesDeployRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/database-services/new': {
      id: '/_main/database-services/new'
      path: '/database-services/new'
      fullPath: '/database-services/new'
      preLoaderRoute: typeof MainDatabaseServicesNewRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/user/settings': {
      id: '/_main/user/settings'
      path: '/user/settings'
      fullPath: '/user/settings'
      preLoaderRoute: typeof MainUserSettingsRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/services/$serviceId': {
      id: '/_main/services/$serviceId'
      path: '/services/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof MainServicesServiceIdRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/sandboxes/$serviceId': {
      id: '/_main/sandboxes/$serviceId'
      path: '/$serviceId'
      fullPath: '/sandboxes/$serviceId'
      preLoaderRoute: typeof MainSandboxesServiceIdRouteRouteImport
      parentRoute: typeof MainSandboxesRouteRoute
    }
    '/_main/one-clicks/$slug': {
      id: '/_main/one-clicks/$slug'
      path: '/$slug'
      fullPath: '/one-clicks/$slug'
      preLoaderRoute: typeof MainOneClicksSlugRouteRouteImport
      parentRoute: typeof MainOneClicksRouteRoute
    }
    '/_main/database-services/$databaseServiceId': {
      id: '/_main/database-services/$databaseServiceId'
      path: '/database-services/$databaseServiceId'
      fullPath: '/database-services/$databaseServiceId'
      preLoaderRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/user/settings/': {
      id: '/_main/user/settings/'
      path: '/'
      fullPath: '/user/settings/'
      preLoaderRoute: typeof MainUserSettingsIndexRouteImport
      parentRoute: typeof MainUserSettingsRouteRoute
    }
    '/_main/services/$serviceId/': {
      id: '/_main/services/$serviceId/'
      path: '/'
      fullPath: '/services/$serviceId/'
      preLoaderRoute: typeof MainServicesServiceIdIndexRouteImport
      parentRoute: typeof MainServicesServiceIdRouteRoute
    }
    '/_main/sandboxes/$serviceId/': {
      id: '/_main/sandboxes/$serviceId/'
      path: '/'
      fullPath: '/sandboxes/$serviceId/'
      preLoaderRoute: typeof MainSandboxesServiceIdIndexRouteImport
      parentRoute: typeof MainSandboxesServiceIdRouteRoute
    }
    '/_main/project/settings/': {
      id: '/_main/project/settings/'
      path: '/project/settings'
      fullPath: '/project/settings/'
      preLoaderRoute: typeof MainProjectSettingsIndexRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/one-clicks/$slug/': {
      id: '/_main/one-clicks/$slug/'
      path: '/'
      fullPath: '/one-clicks/$slug/'
      preLoaderRoute: typeof MainOneClicksSlugIndexRouteImport
      parentRoute: typeof MainOneClicksSlugRouteRoute
    }
    '/_main/database-services/$databaseServiceId/': {
      id: '/_main/database-services/$databaseServiceId/'
      path: '/'
      fullPath: '/database-services/$databaseServiceId/'
      preLoaderRoute: typeof MainDatabaseServicesDatabaseServiceIdIndexRouteImport
      parentRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRoute
    }
    '/organization/deactivate/confirm/$confirmationId': {
      id: '/organization/deactivate/confirm/$confirmationId'
      path: '/organization/deactivate/confirm/$confirmationId'
      fullPath: '/organization/deactivate/confirm/$confirmationId'
      preLoaderRoute: typeof OrganizationDeactivateConfirmConfirmationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/oauth/github/callback': {
      id: '/account/oauth/github/callback'
      path: '/account/oauth/github/callback'
      fullPath: '/account/oauth/github/callback'
      preLoaderRoute: typeof AccountOauthGithubCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/user/settings/organizations': {
      id: '/_main/user/settings/organizations'
      path: '/organizations'
      fullPath: '/user/settings/organizations'
      preLoaderRoute: typeof MainUserSettingsOrganizationsRouteImport
      parentRoute: typeof MainUserSettingsRouteRoute
    }
    '/_main/user/settings/api': {
      id: '/_main/user/settings/api'
      path: '/api'
      fullPath: '/user/settings/api'
      preLoaderRoute: typeof MainUserSettingsApiRouteImport
      parentRoute: typeof MainUserSettingsRouteRoute
    }
    '/_main/services/$serviceId/settings': {
      id: '/_main/services/$serviceId/settings'
      path: '/settings'
      fullPath: '/services/$serviceId/settings'
      preLoaderRoute: typeof MainServicesServiceIdSettingsRouteImport
      parentRoute: typeof MainServicesServiceIdRouteRoute
    }
    '/_main/services/$serviceId/metrics': {
      id: '/_main/services/$serviceId/metrics'
      path: '/metrics'
      fullPath: '/services/$serviceId/metrics'
      preLoaderRoute: typeof MainServicesServiceIdMetricsRouteImport
      parentRoute: typeof MainServicesServiceIdRouteRoute
    }
    '/_main/services/$serviceId/console': {
      id: '/_main/services/$serviceId/console'
      path: '/console'
      fullPath: '/services/$serviceId/console'
      preLoaderRoute: typeof MainServicesServiceIdConsoleRouteImport
      parentRoute: typeof MainServicesServiceIdRouteRoute
    }
    '/_main/sandboxes/$serviceId/metrics': {
      id: '/_main/sandboxes/$serviceId/metrics'
      path: '/metrics'
      fullPath: '/sandboxes/$serviceId/metrics'
      preLoaderRoute: typeof MainSandboxesServiceIdMetricsRouteImport
      parentRoute: typeof MainSandboxesServiceIdRouteRoute
    }
    '/_main/sandboxes/$serviceId/console': {
      id: '/_main/sandboxes/$serviceId/console'
      path: '/console'
      fullPath: '/sandboxes/$serviceId/console'
      preLoaderRoute: typeof MainSandboxesServiceIdConsoleRouteImport
      parentRoute: typeof MainSandboxesServiceIdRouteRoute
    }
    '/_main/one-clicks/$slug/deploy': {
      id: '/_main/one-clicks/$slug/deploy'
      path: '/deploy'
      fullPath: '/one-clicks/$slug/deploy'
      preLoaderRoute: typeof MainOneClicksSlugDeployRouteImport
      parentRoute: typeof MainOneClicksSlugRouteRoute
    }
    '/_main/database-services/$databaseServiceId/settings': {
      id: '/_main/database-services/$databaseServiceId/settings'
      path: '/settings'
      fullPath: '/database-services/$databaseServiceId/settings'
      preLoaderRoute: typeof MainDatabaseServicesDatabaseServiceIdSettingsRouteImport
      parentRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRoute
    }
    '/_main/database-services/$databaseServiceId/roles': {
      id: '/_main/database-services/$databaseServiceId/roles'
      path: '/roles'
      fullPath: '/database-services/$databaseServiceId/roles'
      preLoaderRoute: typeof MainDatabaseServicesDatabaseServiceIdRolesRouteImport
      parentRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRoute
    }
    '/_main/database-services/$databaseServiceId/databases': {
      id: '/_main/database-services/$databaseServiceId/databases'
      path: '/databases'
      fullPath: '/database-services/$databaseServiceId/databases'
      preLoaderRoute: typeof MainDatabaseServicesDatabaseServiceIdDatabasesRouteImport
      parentRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRoute
    }
    '/_main/auth/sso/discourse': {
      id: '/_main/auth/sso/discourse'
      path: '/auth/sso/discourse'
      fullPath: '/auth/sso/discourse'
      preLoaderRoute: typeof MainAuthSsoDiscourseRouteImport
      parentRoute: typeof MainRouteRoute
    }
    '/_main/auth/sso/canny': {
      id: '/_main/auth/sso/canny'
      path: '/auth/sso/canny'
      fullPath: '/auth/sso/canny'
      preLoaderRoute: typeof MainAuthSsoCannyRouteImport
      parentRoute: typeof MainRouteRoute
    }
  }
}

interface MainOneClicksSlugRouteRouteChildren {
  MainOneClicksSlugDeployRoute: typeof MainOneClicksSlugDeployRoute
  MainOneClicksSlugIndexRoute: typeof MainOneClicksSlugIndexRoute
}

const MainOneClicksSlugRouteRouteChildren: MainOneClicksSlugRouteRouteChildren =
  {
    MainOneClicksSlugDeployRoute: MainOneClicksSlugDeployRoute,
    MainOneClicksSlugIndexRoute: MainOneClicksSlugIndexRoute,
  }

const MainOneClicksSlugRouteRouteWithChildren =
  MainOneClicksSlugRouteRoute._addFileChildren(
    MainOneClicksSlugRouteRouteChildren,
  )

interface MainOneClicksRouteRouteChildren {
  MainOneClicksSlugRouteRoute: typeof MainOneClicksSlugRouteRouteWithChildren
  MainOneClicksIndexRoute: typeof MainOneClicksIndexRoute
}

const MainOneClicksRouteRouteChildren: MainOneClicksRouteRouteChildren = {
  MainOneClicksSlugRouteRoute: MainOneClicksSlugRouteRouteWithChildren,
  MainOneClicksIndexRoute: MainOneClicksIndexRoute,
}

const MainOneClicksRouteRouteWithChildren =
  MainOneClicksRouteRoute._addFileChildren(MainOneClicksRouteRouteChildren)

interface MainSandboxesServiceIdRouteRouteChildren {
  MainSandboxesServiceIdConsoleRoute: typeof MainSandboxesServiceIdConsoleRoute
  MainSandboxesServiceIdMetricsRoute: typeof MainSandboxesServiceIdMetricsRoute
  MainSandboxesServiceIdIndexRoute: typeof MainSandboxesServiceIdIndexRoute
}

const MainSandboxesServiceIdRouteRouteChildren: MainSandboxesServiceIdRouteRouteChildren =
  {
    MainSandboxesServiceIdConsoleRoute: MainSandboxesServiceIdConsoleRoute,
    MainSandboxesServiceIdMetricsRoute: MainSandboxesServiceIdMetricsRoute,
    MainSandboxesServiceIdIndexRoute: MainSandboxesServiceIdIndexRoute,
  }

const MainSandboxesServiceIdRouteRouteWithChildren =
  MainSandboxesServiceIdRouteRoute._addFileChildren(
    MainSandboxesServiceIdRouteRouteChildren,
  )

interface MainSandboxesRouteRouteChildren {
  MainSandboxesServiceIdRouteRoute: typeof MainSandboxesServiceIdRouteRouteWithChildren
  MainSandboxesIndexRoute: typeof MainSandboxesIndexRoute
}

const MainSandboxesRouteRouteChildren: MainSandboxesRouteRouteChildren = {
  MainSandboxesServiceIdRouteRoute:
    MainSandboxesServiceIdRouteRouteWithChildren,
  MainSandboxesIndexRoute: MainSandboxesIndexRoute,
}

const MainSandboxesRouteRouteWithChildren =
  MainSandboxesRouteRoute._addFileChildren(MainSandboxesRouteRouteChildren)

interface MainSettingsRouteRouteChildren {
  MainSettingsApiRoute: typeof MainSettingsApiRoute
  MainSettingsBillingRoute: typeof MainSettingsBillingRoute
  MainSettingsPlansRoute: typeof MainSettingsPlansRoute
  MainSettingsRegistryConfigurationRoute: typeof MainSettingsRegistryConfigurationRoute
  MainSettingsIndexRoute: typeof MainSettingsIndexRoute
}

const MainSettingsRouteRouteChildren: MainSettingsRouteRouteChildren = {
  MainSettingsApiRoute: MainSettingsApiRoute,
  MainSettingsBillingRoute: MainSettingsBillingRoute,
  MainSettingsPlansRoute: MainSettingsPlansRoute,
  MainSettingsRegistryConfigurationRoute:
    MainSettingsRegistryConfigurationRoute,
  MainSettingsIndexRoute: MainSettingsIndexRoute,
}

const MainSettingsRouteRouteWithChildren =
  MainSettingsRouteRoute._addFileChildren(MainSettingsRouteRouteChildren)

interface MainVolumesRouteRouteChildren {
  MainVolumesNewRoute: typeof MainVolumesNewRoute
  MainVolumesSnapshotsRoute: typeof MainVolumesSnapshotsRoute
  MainVolumesIndexRoute: typeof MainVolumesIndexRoute
}

const MainVolumesRouteRouteChildren: MainVolumesRouteRouteChildren = {
  MainVolumesNewRoute: MainVolumesNewRoute,
  MainVolumesSnapshotsRoute: MainVolumesSnapshotsRoute,
  MainVolumesIndexRoute: MainVolumesIndexRoute,
}

const MainVolumesRouteRouteWithChildren =
  MainVolumesRouteRoute._addFileChildren(MainVolumesRouteRouteChildren)

interface MainDatabaseServicesDatabaseServiceIdRouteRouteChildren {
  MainDatabaseServicesDatabaseServiceIdDatabasesRoute: typeof MainDatabaseServicesDatabaseServiceIdDatabasesRoute
  MainDatabaseServicesDatabaseServiceIdRolesRoute: typeof MainDatabaseServicesDatabaseServiceIdRolesRoute
  MainDatabaseServicesDatabaseServiceIdSettingsRoute: typeof MainDatabaseServicesDatabaseServiceIdSettingsRoute
  MainDatabaseServicesDatabaseServiceIdIndexRoute: typeof MainDatabaseServicesDatabaseServiceIdIndexRoute
}

const MainDatabaseServicesDatabaseServiceIdRouteRouteChildren: MainDatabaseServicesDatabaseServiceIdRouteRouteChildren =
  {
    MainDatabaseServicesDatabaseServiceIdDatabasesRoute:
      MainDatabaseServicesDatabaseServiceIdDatabasesRoute,
    MainDatabaseServicesDatabaseServiceIdRolesRoute:
      MainDatabaseServicesDatabaseServiceIdRolesRoute,
    MainDatabaseServicesDatabaseServiceIdSettingsRoute:
      MainDatabaseServicesDatabaseServiceIdSettingsRoute,
    MainDatabaseServicesDatabaseServiceIdIndexRoute:
      MainDatabaseServicesDatabaseServiceIdIndexRoute,
  }

const MainDatabaseServicesDatabaseServiceIdRouteRouteWithChildren =
  MainDatabaseServicesDatabaseServiceIdRouteRoute._addFileChildren(
    MainDatabaseServicesDatabaseServiceIdRouteRouteChildren,
  )

interface MainServicesServiceIdRouteRouteChildren {
  MainServicesServiceIdConsoleRoute: typeof MainServicesServiceIdConsoleRoute
  MainServicesServiceIdMetricsRoute: typeof MainServicesServiceIdMetricsRoute
  MainServicesServiceIdSettingsRoute: typeof MainServicesServiceIdSettingsRoute
  MainServicesServiceIdIndexRoute: typeof MainServicesServiceIdIndexRoute
}

const MainServicesServiceIdRouteRouteChildren: MainServicesServiceIdRouteRouteChildren =
  {
    MainServicesServiceIdConsoleRoute: MainServicesServiceIdConsoleRoute,
    MainServicesServiceIdMetricsRoute: MainServicesServiceIdMetricsRoute,
    MainServicesServiceIdSettingsRoute: MainServicesServiceIdSettingsRoute,
    MainServicesServiceIdIndexRoute: MainServicesServiceIdIndexRoute,
  }

const MainServicesServiceIdRouteRouteWithChildren =
  MainServicesServiceIdRouteRoute._addFileChildren(
    MainServicesServiceIdRouteRouteChildren,
  )

interface MainUserSettingsRouteRouteChildren {
  MainUserSettingsApiRoute: typeof MainUserSettingsApiRoute
  MainUserSettingsOrganizationsRoute: typeof MainUserSettingsOrganizationsRoute
  MainUserSettingsIndexRoute: typeof MainUserSettingsIndexRoute
}

const MainUserSettingsRouteRouteChildren: MainUserSettingsRouteRouteChildren = {
  MainUserSettingsApiRoute: MainUserSettingsApiRoute,
  MainUserSettingsOrganizationsRoute: MainUserSettingsOrganizationsRoute,
  MainUserSettingsIndexRoute: MainUserSettingsIndexRoute,
}

const MainUserSettingsRouteRouteWithChildren =
  MainUserSettingsRouteRoute._addFileChildren(
    MainUserSettingsRouteRouteChildren,
  )

interface MainRouteRouteChildren {
  MainOneClicksRouteRoute: typeof MainOneClicksRouteRouteWithChildren
  MainSandboxesRouteRoute: typeof MainSandboxesRouteRouteWithChildren
  MainSettingsRouteRoute: typeof MainSettingsRouteRouteWithChildren
  MainVolumesRouteRoute: typeof MainVolumesRouteRouteWithChildren
  MainActivityRoute: typeof MainActivityRoute
  MainDeployRoute: typeof MainDeployRoute
  MainDomainsRoute: typeof MainDomainsRoute
  MainSecretsRoute: typeof MainSecretsRoute
  MainTeamRoute: typeof MainTeamRoute
  MainIndexRoute: typeof MainIndexRoute
  MainDatabaseServicesDatabaseServiceIdRouteRoute: typeof MainDatabaseServicesDatabaseServiceIdRouteRouteWithChildren
  MainServicesServiceIdRouteRoute: typeof MainServicesServiceIdRouteRouteWithChildren
  MainUserSettingsRouteRoute: typeof MainUserSettingsRouteRouteWithChildren
  MainDatabaseServicesNewRoute: typeof MainDatabaseServicesNewRoute
  MainServicesDeployRoute: typeof MainServicesDeployRoute
  MainServicesNewRoute: typeof MainServicesNewRoute
  MainServicesIndexRoute: typeof MainServicesIndexRoute
  MainAuthSsoCannyRoute: typeof MainAuthSsoCannyRoute
  MainAuthSsoDiscourseRoute: typeof MainAuthSsoDiscourseRoute
  MainProjectSettingsIndexRoute: typeof MainProjectSettingsIndexRoute
}

const MainRouteRouteChildren: MainRouteRouteChildren = {
  MainOneClicksRouteRoute: MainOneClicksRouteRouteWithChildren,
  MainSandboxesRouteRoute: MainSandboxesRouteRouteWithChildren,
  MainSettingsRouteRoute: MainSettingsRouteRouteWithChildren,
  MainVolumesRouteRoute: MainVolumesRouteRouteWithChildren,
  MainActivityRoute: MainActivityRoute,
  MainDeployRoute: MainDeployRoute,
  MainDomainsRoute: MainDomainsRoute,
  MainSecretsRoute: MainSecretsRoute,
  MainTeamRoute: MainTeamRoute,
  MainIndexRoute: MainIndexRoute,
  MainDatabaseServicesDatabaseServiceIdRouteRoute:
    MainDatabaseServicesDatabaseServiceIdRouteRouteWithChildren,
  MainServicesServiceIdRouteRoute: MainServicesServiceIdRouteRouteWithChildren,
  MainUserSettingsRouteRoute: MainUserSettingsRouteRouteWithChildren,
  MainDatabaseServicesNewRoute: MainDatabaseServicesNewRoute,
  MainServicesDeployRoute: MainServicesDeployRoute,
  MainServicesNewRoute: MainServicesNewRoute,
  MainServicesIndexRoute: MainServicesIndexRoute,
  MainAuthSsoCannyRoute: MainAuthSsoCannyRoute,
  MainAuthSsoDiscourseRoute: MainAuthSsoDiscourseRoute,
  MainProjectSettingsIndexRoute: MainProjectSettingsIndexRoute,
}

const MainRouteRouteWithChildren = MainRouteRoute._addFileChildren(
  MainRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  MainRouteRoute: MainRouteRouteWithChildren,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignoutRoute: AuthSignoutRoute,
  AuthSignupRoute: AuthSignupRoute,
  AccountOrganization_invitationsInvitationIdRoute:
    AccountOrganization_invitationsInvitationIdRoute,
  AccountWorkosCallbackRoute: AccountWorkosCallbackRoute,
  AccountOauthGithubCallbackRoute: AccountOauthGithubCallbackRoute,
  OrganizationDeactivateConfirmConfirmationIdRoute:
    OrganizationDeactivateConfirmConfirmationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
